module.exports = __webpack_public_path__ + "img/homeIcon.1916a70c.svg";